<template>
  <div class="bottom">
    <div class="bottom-img"><img src="../../assets/img/home/bottom.png"></div>

    <div class="bottom-contents">
      <!--左 -->
      <div class="bottom-contents-left">
        <div class="title">{{contact.title}}</div>
        <div class="straight-line">
          <div class="straight-line-k"></div>
          <div class="straight-line-x"></div>
        </div>
        <div class="bottom-contents-left-img">
          <img
            class="dizhi"
            src="../../assets/img/home/dizhi.png"
          >
          <div>{{contact.contentSingle.address}}</div>
        </div>

        <div class="bottom-contents-left-img">
          <img
            class="shouji"
            src="../../assets/img/home/shouji.png"
          >
          <div>{{contact.contentSingle.contact_info}}</div>
        </div>

        <div class="bottom-contents-left-img">
          <img
            class="dianhua"
            src="../../assets/img/home/dianhua.png"
          >
          <div>{{contact.contentSingle.phone}}</div>
        </div>

        <div class="bottom-contents-left-img">
          <img
            class="youxiang"
            src="../../assets/img/home/youxiang.png"
          >
          <div>{{contact.contentSingle.email}}</div>
        </div>
      </div>
      <!--左 -->
      <!-- 中 -->
      <div class="bottom-contents-centering">
        <div class="title">
          {{$t('i18n.LicensingandTechnicalSupport')}}
        </div>
        <div class="straight-line">
          <div class="straight-line-k"></div>
          <div class="straight-line-x"></div>
        </div>
        <div class="bottom-contents-centering-text">
          {{system.licensing}}
        </div>
        <div class="title">
          {{$t('i18n.Editquery')}}
        </div>
        <div class="straight-line">
          <div class="straight-line-k"></div>
          <div class="straight-line-x"></div>
        </div>
        <div class="bottom-contents-centering-w">
          {{system.edit_the_query}}
        </div>
        <div class="bottom-contents-centering-w">
          ISNI: {{system.isni}}
        </div>
      </div>
      <!-- 中 -->
      <!-- 右 -->
      <div class="bottom-contents-right">
        <div class="title">
          {{$t('i18n.Netherlands')}}
        </div>
        <div class="straight-line">
          <div class="straight-line-k"></div>
          <div class="straight-line-x"></div>
        </div>
        <div class="bottom-contents-right-text">Jordaniestraat 2 2622HT Delft
        </div>
        <div class="bottom-contents-right-text">Netherlands</div>
        <div class="bottom-contents-right-text">Phone: +31687855321</div>
        <div class="bottom-contents-right-text">Email: info@eaapublishing.org
        </div>
      </div>
      <!-- 右 -->
    </div>

    <div class="bottom-copyright">
      <div>
        Copyright 2000-2019 High-Med All Rights Reserved
        &nbsp;&nbsp;&nbsp;
        备案号：
        <a
          style="color:#fff;text-decoration:none;"
          href="https://beian.miit.gov.cn/"
        >京ICP备2021013735号</a>
      </div>
      <img
        v-if="false"
        class="bottom-copyright-1"
        src="../../assets/img/home/copyright-1.png"
      >
      <img
        v-if="false"
        class="bottom-copyright-2"
        src="../../assets/img/home/copyright-2.png"
      >
      <img
        v-if="false"
        class="bottom-copyright-3"
        src="../../assets/img/home/copyright-3.png"
      >
      <img
        v-if="false"
        class="bottom-copyright-4"
        src="../../assets/img/home/copyright-4.png"
      >
    </div>

  </div>
</template>

<script>
export default {
  name: 'bottom',
  data () {
    return {
      contact: { contentSingle: {} },
      system: {}
    }
  },
  created () {
    this.getContactus()
    this.getSystem()
  },
  methods: {
    //联系我们
    async getContactus () {
      const { data: data } = await this.$http.get('contactus', {
        params: {
          lang: localStorage.getItem('Language')//切换中英文   
        }
      })
      this.contact = data.data
    },
    //系统配置
    async getSystem () {
      const { data: data } = await this.$http.get('system', {
        params: {
          lang: localStorage.getItem('Language')//切换中英文   
        }
      })
      this.system = data.data
    },
  }
}

</script>
<style scoped lang="less">
.bottom {
  width: 100%;
  position: relative;
  .bottom-img {
    position: absolute;
    width: 100%;
    height: 460px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottom-contents {
    position: relative;
    padding: 45px 190px 38px 190px;
    color: #fff;
    display: flex;

    .title {
      font-size: 22px;
      margin-bottom: 20px;
    }
    .straight-line {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      .straight-line-k {
        width: 47px;
        height: 6px;
        background-color: #e06c55;
      }
      .straight-line-x {
        width: 205px;
        height: 1px;
        background-color: #fff;
      }
    }
    .bottom-contents-left {
      margin-right: 240px;
      width: 590px;
      .bottom-contents-left-img {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 28px;
        .dizhi {
          width: 12px;
          height: 17px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .shouji {
          width: 12px;
          height: 17px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .dianhua {
          width: 14px;
          height: 17px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .youxiang {
          width: 15px;
          height: 13px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .bottom-contents-centering {
      margin-right: 235px;
      font-size: 14px;
      .bottom-contents-centering-text {
        margin-bottom: 90px;
      }
      .bottom-contents-centering-w {
        margin-bottom: 20px;
      }
    }
    .bottom-contents-right {
      font-size: 14px;
      .bottom-contents-right-text {
        margin-bottom: 20px;
      }
    }
  }

  .bottom-copyright {
    color: #fff;
    font-size: 14px;
    width: 100%;
    height: 60px;
    background-color: #e06c55;
    padding: 0 450px;

    display: flex;
    align-items: center;

    .bottom-copyright-1 {
      width: 91px;
      height: 17px;
      margin-right: 37px;
      margin-left: 93px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom-copyright-2 {
      width: 86px;
      height: 17px;
      margin-right: 37px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom-copyright-3 {
      width: 56px;
      height: 17px;
      margin-right: 68px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom-copyright-4 {
      width: 274px;
      height: 17px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>